import React, {useEffect} from "react";
import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import {useDispatch, useSelector} from "react-redux";
import {fetchProducts} from "../../store/product-slice";
import ProductList from "../../components/order/ProductList";
import Cart from "../../components/order/Cart";
import {createOrder, fetchCustomer} from "../../store/order-slice";
import {useNavigate} from "react-router-dom";
import {clearCart} from "../../store/cart-slice";

const OrderAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {
        createStatus,
    } = useSelector(state => state.order);

    const userRole = useSelector((state) => state.auth.selectedRole);

    const formSubmitHandler = (data) => {
        dispatch(createOrder({
            ...userRole,
            data,
        }));
    }

    const numberSelectHandler = (phone) => {
        dispatch(fetchCustomer({
            ...userRole,
            phone,
        }));
    }

    useEffect(() => {
        if (createStatus === "success") {
            navigator("..");
        }
        dispatch(clearCart())
    }, [dispatch, createStatus, navigator]);

    useEffect(() => {
        dispatch(fetchProducts({...userRole, orderPage: true}));
    }, [dispatch, userRole]);

    return (
        <>
            <SubHeader title="Create Order" sticky={true}>
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="row gx-6">
                <div className="col-md-6 col-xl-8">
                    <ProductList/>
                </div>
                <div className="col-md-6 col-xl-4">
                    <Cart onSubmit={formSubmitHandler} onNumberSelect={numberSelectHandler}/>
                </div>
            </div>

        </>
    );
};

export default OrderAdd;
